define('onetrust',[
    "jquery",
    "utilities",
    "logging",
    "location"
], function($, utilities, logging, location) {
    "use strict";

    var _ModuleName = "OneTrust";
    var _config = {
        enabled: true,
        triggerTemplate: "<script type='text/plain' class='optanon-category-{{CATEGORY}}'>path = path || {}; path.onetrust = path.onetrust || {}; if(typeof(path.onetrust.allowCategory) =='function') { path.onetrust.allowCategory({{CATEGORY}}); }</script>",
        scriptUrl: "https://cookie-cdn.cookiepro.com/scripttemplates/otSDKStub.js",
        scriptId: "3f93598f-6412-4eae-a452-60ccd114b1eb",
        categories: {
            StrictlyNecessary: 1,
            Performance: 2,
            Functional: 3,
            Targeting: 4,
            SocialMedia: 5
        },
        categoryCount: 5,
        iabCompliance: {
            scriptUrl: "https://cdn.cookielaw.org/opt-out/otCCPAiab.js",
            categories: ["C0004", "C0005"], // categories to opt out of
            location: "all", // all,us,ca
            signedLSPA: true
        }
    };
    var _queues = [ ];
    var _allowed = [ ];

    var init = function() {

        for(var i = 1; i <= _config.categoryCount; i++) {
            _allowed.push(false);
            _queues.push(new Array());
        }

        location.isCookieLawZone(_runInit, _cancelInit);        
    }

    var _runInit = function() {
        ;

        // Attach allowed function to window
        window.path = window.path || {};
        window.path.onetrust = window.path.onetrust || {};
        window.path.onetrust.allowCategory = _allowCategory;

        // Append Trigger Scripts to head
        var triggerScripts = "";
        for(var i = 1; i <= _config.categoryCount; i++) {
            triggerScripts += _getTriggerScript(i);
        }
        $('head').append(triggerScripts);

        // Load OneTrust Script
        _loadScript();

        // Load IAB Cookie Compliance
        _loadIABCompliance();

        // Initialize script wrapper function
        window.OptanonWrapper = function() {};

        ;
    }

    var _cancelInit = function() {
        ;
    }

    var isInitialized = function() {
        if (typeof(window.OneTrust) == undefined) {
            ;
            return false;
        } else {
            ;
        }
        return true;
    }

    var registerScript = function(category, callback) {
        if(typeof(callback) == 'function') {
            if(_isCategoryAllowed(category)) {
                ;
                callback();
            } else {
                ;
                _queues[category - 1].push(callback);
            }
        }
    }

    var _getTriggerScript = function(category) {
        return _config.triggerTemplate.replace(/{{CATEGORY}}/g, category);
    }

    /**
     * Checks if a given category has been marked allowed
     * @param {int} category 
     */
    var _isCategoryAllowed = function(category) {
        if(category > 0) {
            return _allowed[category - 1];
        }
        return false;
    }

    /**
     * Mark a category as allowed
     * @param {int} category 
     */
    var _allowCategory = function(category) {
        if(category > 0) {
            ;
            // Mark Allowed
            _allowed[category - 1];
            // Process Queue
            if(_queues[category - 1].length) {
            ;
                for(var i = 0; i < _queues[category - 1].length; i++) {
                    var callback = _queues[category - 1][i];
                    if(typeof(callback) == 'function') {
                        callback();
                    }
                }
            }
        }
    }

    var _loadScript = function() {
        var onetrust = document.createElement('script');
        onetrust.async = true;
        onetrust.type = 'text/javascript';
        onetrust.charset = 'UTF-8';
        onetrust.setAttribute('data-domain-script', _config.scriptId);
        onetrust.src = _config.scriptUrl;
        var node = document.getElementsByTagName('script')[0];
        node.parentNode.insertBefore(onetrust, node);
    }

    var _loadIABCompliance = function() {
        ;
        var iabCompliance = document.createElement('script');
        iabCompliance.type = 'text/javascript';
        iabCompliance.charset = 'UTF-8';
        iabCompliance.setAttribute('ccpa-opt-out-ids',  _config.iabCompliance.categories.toString());
        iabCompliance.setAttribute('ccpa-opt-out-geo', _config.iabCompliance.location);
        iabCompliance.setAttribute('ccpa-opt-out-lspa', _config.iabCompliance.signedLSPA);
        iabCompliance.src = _config.iabCompliance.scriptUrl;
        var node = document.getElementsByTagName('script')[0];
        node.parentNode.insertBefore(iabCompliance, node);
    }

    return {
        init: init,
        categories: _config.categories,
        registerScript: registerScript,
        isInitialized: isInitialized
    }
});
